/**
 * Handle form where response is JSON
 * e.g. restaurant id validation form
 */

import debug from "debug";

import plugin from '../../lib/plugin';
import { tmpl } from '../../lib/strings';

const MODULE_NAME = 'app.core/modules/ajax-in-place';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-ajax-in-place]';

class AjaxInPlace {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$submitButton = $('[type="submit"]', element);

        this.init();
        this.watch();
    }

    init(){
        // find child elements
        this.$responseContainer = $(this.options.responseContainerSelector, this.$element);
        this.$inputs = $(this.options.inputSelector, this.$element);
        this.$resultsPanel = $(this.options.resultPanelSelector);
        this.$validationMessage = $(this.options.validationMessageSelector, this.$element);

        // form props
        this.options.asyncDataMethod = this.element.method;
        this.options.asyncDataUrl = this.element.action;

        log('AjaxInPlace', this.element, this.options);
    }

    watch() {
        this.$element.on('submit', this.onSubmit.bind(this));
    }

    unwatch() {}

    // only tests for required inputs
    isValid(){
        const invalid = this.$element.find('input[required]').filter(function(){
            return this.value === '';
        }).length;
        return invalid === 0;
    }

    onSubmit(event) {
        event.preventDefault();

        if (!this.isValid()) {
            this.$validationMessage.removeClass('hide');
            return true;
        }

        this.hideValidationMessage();
        this.$submitButton.attr('disabled','disabled').addClass('has-progress');

        $.ajax({
            method: this.options.asyncDataMethod.toLowerCase(),
            url: this.paramatiseFormData(this.options.asyncDataUrl),
            dataType: 'json'
        })
            .then(
                this.onResponseSuccess.bind(this),
                this.onResponseError.bind(this)
            )
            .always(this.hideLoadingIndicator.bind(this));
    }

    hideValidationMessage(){
        this.$validationMessage.addClass('hide');
    }

    hideLoadingIndicator(){
    	this.$submitButton.removeClass('has-progress');
    }

    paramatiseFormData(url) {
        const params = this.$element.serialize();
        return `${url}?${params}`;
    }

    onResponseSuccess(response){
        log('server response', response);
        $(this.options.validationMessageSelector, this.$element).remove();

        this.renderResponse(response);
        (response.Success ? this.onAccept : this.onReject).call(this);
    }

    onResponseError(response){
        log('error', response);
        this.$submitButton.removeAttr('disabled');
        this.renderResponse({
            Success: false,
            Message: this.options.serverErrorMessage
        });
    }

    onAccept(){
        this.$inputs.attr('disabled','disabled');
        this.$resultsPanel.removeAttr('hidden');
    }

    onReject(){
        this.$submitButton.removeAttr('disabled');
    }

    renderResponse(response){
        log('render', response);
        const template = this.options.responseTemplate;
        const model = {
            result: response.Success == true ? 'success' : 'fail',
            message: response.Message
        };

        const rendered = tmpl(template, model);
        this.$responseContainer.html(rendered);
    }

}

AjaxInPlace.DEFAULTS = {
    asyncDataUrl: null, // pull instead from form action
    asyncDataMethod: 'POST', // pull instead from form method
    asyncDataEmitTargetAttribute: 'data-ajax-in-place--async-data-on',
    asyncDataRenderAttribute: 'data-ajax-in-place--async-data-bind',
    validationMessageSelector: '.field-validation-error',
    inputSelector: 'input[type=text]',
    responseContainerSelector:'[data-ajax-in-place-response]',
    responseTemplate:'{{result}}: {{message}}',
    serverErrorMessage: 'Failed to connect to the server',
    resultPanelSelector: '[data-ajax-in-place--success-panel]'
    // submitButton selector ?
};

plugin('ajaxInPlace', AjaxInPlace);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).ajaxInPlace();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./client/src/core/modules/ajax-in-place/index.js